import React from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import eccss from "../../../styles/ExternalCalls.module.css"
import { LoaderMedium } from "../../../components/Loaders"
import NoData from "../NoData"
import { ReactComponent as BoxMessageIcon } from "../resources/box_messages.svg"
import { Tooltip } from "primereact/tooltip"
import { capitalizeFirstLetter } from "../Utils"
import { Button } from "primereact/button"

export default function CallHistory({ callHistory, loadingCalls, refresh }) {

  const errorTemplate = (rowData, { rowIndex }) => {
    if (rowData.errorMessage) {
      return <>
        <i id={`error_icon_${rowIndex}`}
          className="pi pi-exclamation-circle"
          style={{ color: 'red' }}
        />
        <Tooltip target={`#error_icon_${rowIndex}`} className="custom-tooltip" position='bottom'>
          <span>
            ({rowData.errorCode || "0000"}) {capitalizeFirstLetter(rowData.errorMessage)}
          </span>
        </Tooltip>
      </>
    }
  }

  return (
    <div className={eccss.historyWrapper}>
      <div className={eccss.historyHeader}>
        <div className={eccss.historyHeaderText}>
          Call History
        </div>
        <Button
          icon="pi pi-refresh"
          className={eccss.historyRefreshBtn}
          onClick={refresh}
        />
      </div>
      <div className={eccss.historyBody}>
        {loadingCalls &&
          <LoaderMedium />
        }
        {!loadingCalls && callHistory.length === 0 &&
          <div className={eccss.no_record_div}>
            <NoData
              icon={
                <BoxMessageIcon
                  style={{ padding: "8px", width: "100%", height: "100%" }}
                />
              }
            />
            <div style={{ width: "400px" }}>
              <p style={{ fontWeight: "600" }}>
                No external calls
              </p>
            </div>
          </div>
        }
        {!loadingCalls && callHistory.length > 0 &&
          <DataTable
            value={callHistory}
            tableClassName={eccss.custom_table}
            scrollable
            scrollHeight="62vh"
          >
            <Column field="date" header="Date" />
            <Column field="time" header="Time" />
            <Column field="duration" header="Duration" />
            <Column field="from" header="From" />
            <Column field="to" header="To" />
            <Column header="Error" body={errorTemplate} />
          </DataTable>
        }
      </div>
    </div>
  )
}
